const EVENTS = {
        CLICK: 'click'
    },

    CARD_TYPES = {
        CARD: 'card',
        LIST: 'list'
    },

    CARD_SIZES = {
        MEDIUM: 'medium',
        LARGE: 'large'
    },

    PLATFORMS = {
        MIXPANEL: 'mixpanel',
        GRAPHITE: 'graphite',
        BIGQUERY: 'bigquery'
    };

function reportToGraphite(evt) {
    const cardType = evt.cardType === 'card' ? `${evt.cardSize}_${evt.cardType}` : evt.cardType;
    const data = {
        label: `fe_events.react_${cardType}.${evt.name}`,
        percentage: evt.percentage || 100
    };

    if (evt.timing) {
        data.timing = evt.timing;
    }

    if (typeof Fiverr !== 'undefined' && Fiverr._logEventToGraphite) {
        Fiverr._logEventToGraphite(data);
    } else {
        console && console.log('Sandbox Graphite logging', data); // eslint-disable-line
    }
}

function reportToMixpanel(evt, dontIgnore) {
    if (dontIgnore) { // temporary
        if (typeof MixpanelWrapper !== 'undefined') {
            MixpanelWrapper.trackEvent(MixpanelWrapper.Events.GigCardEvents.CLICKED_CARD, evt.payload);
        } else {
            console && console.log('Sandbox Mixpanel logging', evt.payload); // eslint-disable-line
        }
    }
}

function reportToBigquery(evt) {
    const currentPage = document && document.pageScope && document.pageScope.main || '';
    let data = {
        type: evt.name,
        current_page_type: currentPage
    };

    data = Object.assign(evt.payload, data);

    if (typeof Fiverr.sendClientEvents === 'undefined') {
        console && console.log('Sandbox BigQuery logging', data); // eslint-disable-line
        return;
    }

    Fiverr.sendClientEvents(data);
}

function prepareEventData(eventName, cardType, cardSize, eventType, payload, platform) {
    const evt = {
        name: eventName,
        type: eventType || EVENTS.CLICK,
        cardType,
        payload: payload || {},
        platform: platform || null
    };

    evt.payload.Subcategory = Fiverr && Fiverr.models && Fiverr.models.ps.subCatName || 'search';
    evt.payload['Click Location'] = evt.name;
    evt.payload['Card Type'] = cardType;
    evt.payload['Card Size'] = cardSize;

    return evt;
}

export function trackTime(eventName, startTime, cardType = CARD_TYPES.CARD) {
    const evt = {
        name: eventName,
        cardType,
        timing: Date.now() - startTime,
        percentage: 20
    };

    if (evt.timing) {
        reportToGraphite(evt);
    }
}

export function trackEvent(eventName, cardType = CARD_TYPES.CARD, cardSize = CARD_SIZES.MEDIUM, eventType = EVENTS.CLICK, payload, platform) {
    const evt = prepareEventData(eventName, cardType, cardSize, eventType, payload, platform);

    if (!evt.name){
        return;
    }

    switch (platform) {
        case PLATFORMS.GRAPHITE:
            reportToGraphite(evt);
            break;
        case PLATFORMS.MIXPANEL:
            reportToMixpanel(evt);
            break;
        case PLATFORMS.BIGQUERY:
            reportToBigquery(evt);
            break;
        default:
            reportToMixpanel(evt);
            reportToGraphite(evt);
            break;
    }
}



// WEBPACK FOOTER //
// ./src/utils/tracking.js